export const en = {
    choose_goal: 'Choose a goal',
    conf: 'Conference',
    goal: 'Goal',
    trip: 'Business trip',
};
